const actionTypeIdentifier = "A3C91F9C-4B43-4253-8FAA-0CF15EB91B66";

export const setRechargingHistoryLogsLoading = `SET-RECHARGING-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getRechargingHistoryLogs = `GET-RECHARGING-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setRechargingHistoryPageSize = `SET-RECHARGING-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetRechargingHistory = `RESET-RECHARGING-HISTORY-${actionTypeIdentifier}`;
export const setRechargingHistoryColSearchStr = `SET-RECHARGING-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
